import styled from "styled-components";
import Colors from "../../../shared/colors";

export default styled.div`
  background: ${Colors.alabaster};
  padding: 140px 0px 100px 0px;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;

  .layout {
    max-width: 1100px;
    margin: 0 auto;

    @media screen and (max-width: 1200px) {
      max-width: 800px;
    }

    @media screen and (max-width: 850px) {
      max-width: 600px;
    }
  }

  .patients {
    .col {
      display: table;
      background: ${Colors.mercury};
      margin: 5px;
      padding: 27px 34px;
      min-height: 155px;
      cursor: pointer;
      height: 175px;
      width: 24%;
    }

    .center-content {
      display: table-cell;
      vertical-align: middle;
    }

    .main-text {
      color: ${Colors.mineShaft};
      height: 20px;
      margin-bottom: 5px;
    }

    .wrapper-number {
      display: flex;
      justify-content: space-between;

      .number {
        color: ${Colors.aquaDeep};
      }
    }

    .details {
      color: ${Colors.aquaDeep};
    }
  }

  .referTo {
    margin-top: 150px;
    margin-bottom: 75px;

    .col {
      margin: 5px;
      padding: 68px 62px;
      position: relative;
      z-index: 1;
    }

    .bullet-1 {
      position: absolute;
      right: 20px;
      bottom: 20px;
      z-index: -1;
    }

    .bullet-2 {
      position: absolute;
      top: 80px;
      right: 10%;
      z-index: -1;
    }

    .bullet-3 {
      position: absolute;
      top: 30px;
      right: 25%;
      z-index: -1;
    }

    .first {
      background: linear-gradient(
        100.13deg,
        rgba(181, 210, 200, 0.9) -12.14%,
        rgba(181, 210, 200, 0.9) 203.78%
      );
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    }

    .second {
      background-color: rgba(181, 210, 200, 1);
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    }

    .main-text {
      color: ${Colors.mineShaft};
    }

    .second-text {
      color: ${Colors.mineShaft};
      margin-top: 5px;
      margin-bottom: 30px;
      min-height: 38px;
      width: 80%;
      height: 57px;
    }

    img {
      margin-bottom: 15px;
    }
  }
`;
